import { render, staticRenderFns } from "./SearchContacts.vue?vue&type=template&id=281bceb0&scoped=true&"
import script from "./SearchContacts.vue?vue&type=script&lang=js&"
export * from "./SearchContacts.vue?vue&type=script&lang=js&"
import style0 from "./SearchContacts.vue?vue&type=style&index=0&id=281bceb0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281bceb0",
  null
  
)

export default component.exports